if (!customElements.get('description-expander')) {
  customElements.define(
    'description-expander',
    class DescriptionExpander extends HTMLElement {
      constructor() {
        super();
        this.description = this.querySelector('.product__description, .collection-hero__description');
        this.button = this.querySelector('button');

        if (!this.button) return;

        this.readMoreText = this.button.textContent;
        this.showLessText = this.dataset.showLessText;
        this.button.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        this.description.classList.toggle('collapsed');
        const isExpanded = !this.description.classList.contains('collapsed');

        this.button.setAttribute('aria-expanded', isExpanded);
        this.button.textContent = isExpanded ? this.showLessText : this.readMoreText;
      }
    }
  );
} 
